module.exports = __webpack_public_path__ + "static/media/BlogIndexPage.7e8818a2.jpeg";